export default function crmSalon({ next, store, to }) {
  if (!store.getters.auth) {
    return next({ name: 'Login' })
  }
  try {
    const email = (JSON.parse(localStorage.getItem('utilisateur') || '{}').email || '').toLowerCase()
    const allowed = [
      'e.marquet@weedoit.fr',
      'k.ghalem@weedoit.fr',
      'a.gorani@weedoit.fr',
      's.boukbir@weedoit.fr'
    ]
    if (allowed.includes(email)) {
      return next()
    }
  } catch (e) {
    // fallthrough
  }
  return next({ name: 'Dashboard layout' })
}
